import { createTranslationsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useTranslationsQuery = createTranslationsQuery(HTTP_CONFIG.API.Optimizely.url)
